import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { useAriaAndDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { Text } from '@famly/mf_data-display_text';
const variantStyles = {
    default: { backgroundColor: 'n50', borderColor: 'n100', color: 'n400' },
    inverted: { backgroundColor: 'n400', borderColor: 'n100', color: 'n50' },
    info: { backgroundColor: 'n25', borderColor: 'b400', color: 'n400' },
    warn: { backgroundColor: 'n25', borderColor: 'y400', color: 'n400' },
    error: { backgroundColor: 'n25', borderColor: 'r400', color: 'n400' },
};
export const Tooltip = (props) => {
    const { children, tooltipContent, placement = 'top', isDisabled, open, variant = 'default', disableInteractive = true, maxWidth = 245, followCursor, enterDelay, leaveDelay, ...rest } = props;
    const { borderColor, backgroundColor, color } = variantStyles[variant];
    const dataAriaProps = useAriaAndDataProps(props);
    const popperSx = React.useMemo(() => ({
        '& .MuiTooltip-tooltip': {
            border: (theme) => `1px solid ${theme.modernFamlyTheme.colorPalette[borderColor]}`,
            backgroundColor: (theme) => theme.modernFamlyTheme.colorPalette[backgroundColor],
            color: (theme) => theme.modernFamlyTheme.colorPalette[color],
            paddingX: 3,
            paddingY: 2,
            maxWidth,
        },
    }), [borderColor, backgroundColor, color, maxWidth]);
    return (_jsx(MuiTooltip, { title: typeof tooltipContent === 'string' ? _jsx(Text, { variant: "subtitle", children: tooltipContent }) : tooltipContent, placement: placement, open: open, disableFocusListener: isDisabled, disableHoverListener: isDisabled, disableTouchListener: isDisabled, disableInteractive: disableInteractive, followCursor: followCursor, enterDelay: enterDelay, leaveDelay: leaveDelay, componentsProps: {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -6],
                        },
                    },
                ],
                sx: popperSx,
            },
        }, ...rest, ...dataAriaProps, children: children }));
};
